import { useEffect, useRef } from 'react';

function StarBackground() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const stars = [];
    const starCount = 50;

    // Créer les étoiles filantes
    for (let i = 0; i < starCount; i++) {
      stars.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 2,
        vy: (Math.random() - 0.5) * 2,
        radius: Math.random() * 1 + 0.5,
        opacity: Math.random() * 0.5 + 0.3,
      });
    }

    const animate = () => {
      // Fond transparent pour l'effet de traîne
      ctx.fillStyle = 'rgba(245, 245, 240, 0.02)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Dessiner et animer les étoiles
      stars.forEach((star) => {
        star.x += star.vx;
        star.y += star.vy;

        // Rebond sur les bords
        if (star.x < 0 || star.x > canvas.width) star.vx *= -1;
        if (star.y < 0 || star.y > canvas.height) star.vy *= -1;

        // Garder les étoiles dans le canvas
        star.x = Math.max(0, Math.min(canvas.width, star.x));
        star.y = Math.max(0, Math.min(canvas.height, star.y));

        // Dessiner l'étoile
        ctx.fillStyle = `rgba(100, 100, 120, ${star.opacity})`;
        ctx.beginPath();
        ctx.arc(star.x, star.y, star.radius, 0, Math.PI * 2);
        ctx.fill();

        // Traîne optionnelle
        ctx.strokeStyle = `rgba(120, 120, 150, ${star.opacity * 0.3})`;
        ctx.lineWidth = 0.5;
        ctx.beginPath();
        ctx.moveTo(star.x, star.y);
        ctx.lineTo(star.x - star.vx * 5, star.y - star.vy * 5);
        ctx.stroke();
      });

      requestAnimationFrame(animate);
    };

    animate();

    // Gestion du resize
    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fixed top-0 left-0 w-full h-full pointer-events-none"
      style={{ opacity: 0.3 }}
    />
  );
}

export default StarBackground;
